import RelationshipMetadata from "../../RelationshipMetadata";

class AccountUserAccountUserUserGroupRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AccountUserAccountUserUserGroupRelationshipMetadata";
        this.parentEnterpriseComponent = "AccountUser";
        this.childEnterpriseComponent = "AccountUserUserGroup";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "UserGroupUSID";
    }
}

export default AccountUserAccountUserUserGroupRelationshipMetadata;